// frontend/src/pages/PaymentPending.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentPending = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const paymentId = params.get('payment_id');
    const amount = params.get('amount');

    return (
        <div
            className="min-h-screen flex items-center justify-center px-4 py-12"
            style={{ backgroundColor: '#0A1929' }}
        >
            <div className="w-full max-w-md">
                <div
                    className="rounded-[24px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                    style={{ backgroundColor: '#0E2238', border: '2px solid rgba(255,255,255,0.1)' }}
                >
                    {/* Icon + título */}
                    <div className="px-8 pt-10 pb-7 text-center"
                        style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5"
                            style={{ backgroundColor: 'rgba(234,179,8,0.15)', border: '2px solid #EAB308' }}>
                            <span className="text-4xl">⏳</span>
                        </div>
                        <h2 className="text-2xl font-extrabold text-white mb-2">Pago Pendiente</h2>
                        <p className="text-white/50 text-sm">
                            {amount
                                ? <>Tu compra de <span className="text-[#FCE503] font-bold">{amount} tickets</span> está siendo procesada.</>
                                : 'Tu pago está siendo procesado.'
                            }
                            {' '}Te notificaremos cuando se complete.
                        </p>
                    </div>

                    {/* Detalle */}
                    {paymentId && (
                        <div className="px-8 py-5"
                            style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                            <p className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">Detalle</p>
                            <div className="flex flex-col gap-3">
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-white/40">ID de pago</span>
                                    <span className="text-white font-semibold">{paymentId}</span>
                                </div>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-white/40">Estado</span>
                                    <span className="font-bold" style={{ color: '#EAB308' }}>En revisión</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Info box */}
                    <div className="mx-8 mt-5 rounded-xl px-4 py-3 text-xs text-white/50"
                        style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                        Los pagos pendientes suelen resolverse en menos de 24 horas. Si tenés algún problema, contactá a soporte.
                    </div>

                    {/* Botones */}
                    <div className="px-8 py-6 flex flex-col gap-3">
                        <button
                            onClick={() => navigate('/')}
                            className="w-full h-12 rounded-[14px] font-bold text-sm uppercase tracking-wider
                                       transition-transform hover:scale-[1.02] active:scale-[0.98]"
                            style={{ backgroundColor: '#FCE503', color: '#122436', border: '2px solid #E5CF03' }}
                        >
                            Ir al inicio
                        </button>
                        <button
                            onClick={() => navigate('/recharge')}
                            className="w-full h-12 rounded-[14px] font-bold text-sm uppercase tracking-wider
                                       text-white/50 hover:text-white/80 transition-colors"
                        >
                            Intentar otro pago
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentPending;
